import { TLUiMenuGroup, TLUiOverrides, menuItem, toolbarItem } from '@tldraw/tldraw'

export const uiOverrides: TLUiOverrides = {
	tools(editor, tools) {
		// Delete hand keyboard shortcut
		delete tools.hand.kbd;
		// Delete arrow keyboard shortcut
		delete tools.arrow.kbd;
		// Delete text keyboard shortcut
		delete tools.text.kbd;
		// Delete note keyboard shortcut
		delete tools.note.kbd;
		// Delete asset keyboard shortcut
		delete tools.asset.kbd;
		// Delete frame keyboard shortcut
		delete tools.frame.kbd;
		// Delete highlight keyboard shortcut
		delete tools.highlight.kbd;
		// Delete laser keyboard shortcut
		delete tools.laser.kbd;
		return tools
	},
    toolbar(_app, toolbar, { tools }) {
        // Delete hand tool
		toolbar.splice(1, 1);
        // Delete arrow, text, note, asset
		toolbar.splice(3, 4);
        // Delete x-box, checkbox
		toolbar.splice(13, 2);
        // Delete frame
		toolbar.splice(17, 1);
        // Delete highlight, laser
		toolbar.splice(18, 2);
		return toolbar
	},
    helpMenu(editor, helpMenu, { actions }) {
		return []
	},
    contextMenu(editor, contextMenu, { actions }) {
		return []
	},
}